module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-image/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Cro Metrics Support Wiki","description":"Cro Metrics Support Wiki","start_url":"/","icon":"src/global/assets/favicon.png","hostname":"crometrics.atlassian.net","auth":"Basic YW5hbHl0aWNzQGNyb21ldHJpY3MuY29tOnBFSGJiYld5SW5lc3dnMFpLcmpYNTRGNA==","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"05f5dfcfbbb95a461db80fc4ca1687b7"},
    }]
